require("bootstrap");
var toastr = require("toastr");

(function () {

    $(document).ready(function () {
        //Notificationer beskeder
        if (window.successMessage !== undefined && window.successMessage.length > 0) {
            var successMessages = window.successMessage.split(";");
            for (var i = 0; i < successMessages.length; i++) {
                window.showSuccessNotification(successMessages[i]);
            }

        }
        if (window.infoMessage !== undefined && window.infoMessage.length > 0) {
            var infoMessages = window.infoMessage.split(";");
            for (var k = 0; k < infoMessages.length; k++) {
                window.showInfoNotification(infoMessages[k]);
            }
        }
        if (window.errorMessage !== undefined && window.errorMessage.length > 0) {
            var errorMessages = window.errorMessage.split(";");
            for (var j = 0; j < errorMessages.length; j++) {
                window.showErrorNotification(errorMessages[j]);
            }
        }
    });

    window.showSuccessNotification = function (message) {
        toastr.success(message);
    }

    window.showErrorNotification = function (message) {
        toastr.error(message);
    }

    window.showInfoNotification = function (message) {
        toastr.info(message);
    }

})();



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/shared.js
// module id = 0
// module chunks = 9